
import ProgressBar from "@ramonak/react-progress-bar";
import Slider from 'rc-slider';
import { ReactComponent as BlockplayerDownload } from '../../assets/icons/blockplayer-download.svg';
import { ReactComponent as BlockplayerForward } from '../../assets/icons/blockplayer-forward.svg';
import { ReactComponent as BlockplayerFullscreen } from '../../assets/icons/blockplayer-fullscreen.svg';
import { ReactComponent as BlockplayerMuteIcon } from '../../assets/icons/blockplayer-mute.svg';
import { ReactComponent as BlockplayerPipFill } from '../../assets/icons/blockplayer-pip-fill.svg';
import { ReactComponent as BlockplayerPip } from '../../assets/icons/blockplayer-pip.svg';
import { ReactComponent as BlockplayerPlay } from '../../assets/icons/blockplayer-play.svg';
import { ReactComponent as BlockplayerPush } from '../../assets/icons/blockplayer-push.svg';
import { ReactComponent as BlockplayerRepeat } from '../../assets/icons/blockplayer-repeat.svg';
import { ReactComponent as BlockplayerRewind } from '../../assets/icons/blockplayer-rewind.svg';
import { ReactComponent as BlockplayerUnMuteIconMd } from '../../assets/icons/blockplayer-unmute-md.svg';
import { ReactComponent as BlockplayerUnMuteIconSm } from '../../assets/icons/blockplayer-unmute-sm.svg';
import { ReactComponent as BlockplayerUnMuteIcon } from '../../assets/icons/blockplayer-unmute.svg';





    export default function BlockPlayerControls({
        pipcontrols,
        bigplayctr,
        playcontrols,
        restartcontrols,
        rewindcontrols,
        forwardcontrols,
        progresscontrols,
        mutecontrols,
        volumecontrols,
        fullscreencontrols,
        downloadcontrols,
        ReactPlayer,
        url,
        initialPip,
        BlockPlayerPip,
        initialPlaying,
        BlockPlayerPlayPause,
        BigplayctrHide,
        initialBigplayHide,
        BlockPlayerPlayRewind,
        BlockPlayerPlayForward,
        BlockPlayerMute,
        initialMute, 
        BlockPlayerScreenfull, 
        initialPlayed,
        onSeekBlockPlayer,
        onSeekMouseDownBlockPlayer,
        onSeekMouseUpBlockPlayer,
        onDurationBlockPlayer,
        // initialDuration,
        // currentTime,
        // timeWeHave,
        // totalDuration,
        elapsedTime,
        onChangeVolume,
        initialVolume,
        onChangeCommittedVolume,
        // handleSetPlaybackRate,
        // initPlaybackRate,
        initialLoaded,
        BlockPlayerRestarte
    }) {
    
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <div className="blockplayer-controls-area">
                
                <div className="blockplayer-controls-overlay"
                onClick={(playingEvent) => BlockPlayerPlayPause(playingEvent)}
                >
                    {!initialPlaying && 
                        <div className='blockplayer-play-icon-overlay'>
                            <button>
                                <BlockplayerPlay
                                    viewBox="0 0 24 24"
                                />
                            </button>
                        </div>
                    }
                </div>
            {progresscontrols &&
                <div className="blockplayer-controls-mdl">
                    <div className='blockplayer-video-load-area'>
                        <ProgressBar 
                            className="blockplayer-loaded-bar"
                            completed={initialLoaded}
                            height="3px"
                            borderRadius="0"
                            isLabelVisible={false}
                            bgColor={'#ff6060'}
                            baseBgColor="#ffffff00"
                            labelSize="0"
                            margin="0"
                            padding="0"
                            transitionTimingFunction="ease"
                        />
                        <Slider
                            dotStyle={{ borderColor: 'orange' }}
                            activeDotStyle={{ borderColor: 'yellow' }}
                            
                            railStyle={{ 
                                height: 3,
                                cursor: 'pointer',
                                borderRadius: 0,
                                backgroundColor: '#ffffff40',
                             }}
                            trackStyle={{
                                height: 3,
                                cursor: 'pointer',
                                borderRadius: 0,
                                backgroundColor: '#ffffff',
                            }}
                            handleStyle={{
                                height: 13,
                                width: 13,
                                marginTop: -5,
                                marginLeft: 0,
                                backgroundColor: '#222',
                                border: '1px solid #ffffff',
                                boxShadow: 'inherit',
                            }}

                            min={0}
                            max={100}
                            defaultValue={initialPlayed * 100} 
                            value={initialPlayed * 100} 
                            onChange={
                                e => onSeekBlockPlayer(e)
                            }
                            onBeforeChange={
                                e => onSeekMouseDownBlockPlayer(e)
                            }
                            onAfterChange={
                                e => onSeekMouseUpBlockPlayer(e)
                            }
                        />
                    </div>
                </div>
            }
            <div className="blockplayer-controls-bottom">
                <div className="blockplayer-controls-bottom-left">
                    {restartcontrols &&
                        <div className='blockplayer-restart-area'>
                            <button className='blockplayer-restart'
                                onClick={(restartEvent) => BlockPlayerRestarte(restartEvent)}
                            >
                                <BlockplayerRepeat
                                    viewBox="0 0 24 24"
                                />
                            </button>
                        </div>
                    }
                    {rewindcontrols &&
                        <div className='blockplayer-rewind-area'>
                            <button className='blockplayer-rewind'
                                onClick={(rewindEvent) => BlockPlayerPlayRewind(rewindEvent)}
                            >
                                <BlockplayerRewind
                                    viewBox="0 0 24 24"
                                /> 
                            </button>
                        </div>
                    }
                    {playcontrols &&
                        <div className='blockplayer-playing-area'>
                            <button className='blockplayer-playing'
                                onClick={(playingEvent) => BlockPlayerPlayPause(playingEvent)}
                            >
                                {initialPlaying ?
                                    <BlockplayerPush
                                        viewBox="0 0 24 24"
                                    />
                                    :
                                    <BlockplayerPlay
                                        viewBox="0 0 24 24"
                                    /> 
                                }
                            </button>
                        </div>
                    }
                    {forwardcontrols &&
                        <div className='blockplayer-forward-area'>
                            <button className='blockplayer-forward'
                                onClick={(forwardEvent) => BlockPlayerPlayForward(forwardEvent)}
                            >
                                <BlockplayerForward
                                    viewBox="0 0 24 24"
                                /> 
                            </button>
                        </div>
                    }
                    {mutecontrols &&
                        <div className='blockplayer-mute-unmute-area'>
                            <button className='blockplayer-mute-unmute'
                                onClick={(muteEvent) => BlockPlayerMute(muteEvent)}
                            >
                                {initialMute &&
                                    <BlockplayerMuteIcon
                                        viewBox="0 0 24 24"
                                    />
                                }
                                {initialVolume <= 1 && initialVolume >= 0.70 && !initialMute &&
                                    <BlockplayerUnMuteIcon
                                        viewBox="0 0 24 24"
                                    />
                                }
                                {initialVolume <= 0.69 && initialVolume >= 0.40 && !initialMute &&
                                    <BlockplayerUnMuteIconMd
                                        viewBox="0 0 24 24"
                                    />
                                }
                                {initialVolume <= 0.39 && initialVolume > 0 && !initialMute &&
                                    <BlockplayerUnMuteIconSm
                                        viewBox="0 0 24 24"
                                    />
                                }
                            </button>
                        </div>
                    }
                    {volumecontrols &&
                        <div className='blockplayer-volume-slider-area'>
                            <Slider
                                
                                railStyle={{ 
                                    height: 3,
                                    cursor: 'pointer',
                                    borderRadius: 0,
                                    backgroundColor: '#ffffff40',
                                }}
                                trackStyle={{
                                    height: 3,
                                    cursor: 'pointer',
                                    borderRadius: 0,
                                    backgroundColor: '#ffffff',
                                }}
                                handleStyle={{
                                    height: 13,
                                    width: 13,
                                    marginTop: -5,
                                    marginLeft: 0,
                                    backgroundColor: '#222',
                                    border: '1px solid #ffffff',
                                    boxShadow: 'inherit',
                                }}
                                
                                min={0}
                                max={100}
                                defaultValue={initialVolume * 100}
                                onChange={ e => onChangeVolume(e) }
                            />
                        </div>
                    }
                </div>
                <div className="blockplayer-controls-bottom-right">
                    {pipcontrols &&
                        ReactPlayer.canEnablePIP(url) &&
                            <div className='blockplayer-pip-area'>
                                <button className='blockplayer-pip'
                                    onClick={(pipEvent) => BlockPlayerPip(pipEvent)}
                                >
                                    {initialPip ?
                                        <BlockplayerPipFill
                                            viewBox="0 0 24 24"
                                        />
                                        :
                                        <BlockplayerPip
                                            viewBox="0 0 24 24"
                                        />    
                                    }
                                </button>
                            </div>
                    }
                    {downloadcontrols &&
                        <div className='blockplayer-download-area'>
                            <a className='blockplayer-download' href={url}>
                                <BlockplayerDownload
                                    viewBox="0 0 24 24"
                                />
                            </a>
                        </div>
                    }
                    {fullscreencontrols &&
                        <div className='blockplayer-full-screen-area'>
                            <button className='blockplayer-full-screen'
                                onClick={(screenfullEvent) => BlockPlayerScreenfull(screenfullEvent)}
                            >                       
                                <BlockplayerFullscreen
                                    viewBox="0 0 24 24"
                                /> 
                            </button>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}